export default "<div class=\"alert alert-app-level\"></div>"